import React, { useReducer } from "react";

import Input from "components/input/input";
import Button from "components/button/button";
import { INITIAL_FIELD_VALUE } from "constants/common";
import MergeStateReducer from "utils/mergeStateReducer";
import { handleLogOut } from "utils/logOut";
import usePartyAccounts from "hooks/usePartyAccounts";
import Environment from "services/environment";

import styles from "./partyInput.scss";
import { enablePlatformLogin } from "utils/platformUtils";

const {
  party_input_container,
  party_input_card,
  party_input_title,
  party_input_logout,
  party_input_logout_link,
  party_input_details,
} = styles;

const PartyInput = ({ onSelectAccount, closePartySelector }) => {
  const [partyId, setPartyId] = useReducer(MergeStateReducer, INITIAL_FIELD_VALUE);
  const isProceedDisabled = partyId.value ? partyId.errors.length !== 0 : !partyId.value;
  const { fetchPartyAccounts } = usePartyAccounts();
  const env = Environment.getEnv();

  const onChange = (value) => {
    setPartyId({
      value,
      errors: [],
      touched: false,
    });
  };

  const onProceed = () => {
    fetchPartyAccounts({
      limit: 10,
      offSet: 0,
      partyIdFromUrl: partyId.value,
    }).then((response) => {
      if (response.data.code && response.data.message) {
        setPartyId({
          value: partyId.value,
          errors: [response.data.message],
          touched: true,
        });
        return;
      }
      const partyDetails = response.data.data.userPartyData[0].partyAccounts[0];
      onSelectAccount(partyDetails);
      closePartySelector();
    });
  };

  const onLogout = () => {
    const isPlatformEnabled = enablePlatformLogin();
    if (isPlatformEnabled) {
      window.location.href = env.selfcareLoginPageBaseUrl + "logout";
    } else {
      handleLogOut("ATB_SKAM_LOGOUT_CLICK");
    }
  };

  return (
    <div className={party_input_container}>
      <div className={party_input_details}>
        <div className={party_input_card}>
          <h2 className={party_input_title}>Which Customer’s Party you want to take action on?</h2>
          <Input
            name="partyId"
            type="text"
            value={partyId.value}
            isValidChange={(value) => /^[0-9]*$/.test(value)}
            onChange={onChange}
            label="Customer’s Party ID"
            placeholder="Customer’s Party ID"
            touched={partyId.touched}
            errors={partyId.errors}
            required
          />
          <Button displayName="Proceed" disabled={isProceedDisabled} onClick={onProceed} />
        </div>
        <div className={party_input_logout}>
          Are you done?{" "}
          <span onClick={onLogout} className={party_input_logout_link}>
            Logout
          </span>
        </div>
      </div>
    </div>
  );
};

export default PartyInput;
